import { render, staticRenderFns } from "./RecentActivityTableDescriptionBookingRefunded.vue?vue&type=template&id=2943fe0e&"
import script from "./RecentActivityTableDescriptionBookingRefunded.vue?vue&type=script&lang=js&"
export * from "./RecentActivityTableDescriptionBookingRefunded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports